import { render, staticRenderFns } from "./ContactMergeModal.vue?vue&type=template&id=4d04a56f&scoped=true&"
import script from "./ContactMergeModal.vue?vue&type=script&lang=js&"
export * from "./ContactMergeModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d04a56f",
  null
  
)

export default component.exports